/**
 * Order-preserving schema fingerprint for the "one schema per group" rule (F2).
 *
 * "Same schema within a group" means the same column names in the SAME ORDER —
 * strict order is what makes a group representative's column INDEXES valid for
 * every sibling file by construction (the scrub plan and the identity seam are
 * index-keyed). The old signature (`names.join(' ')`) was order-insensitive at
 * match time elsewhere and COLLIDED `["A B"]` with `["A", "B"]`; this encoding is
 * collision-free: a JSON array of the trimmed names, so no separator can ever be
 * confused with name content.
 *
 * Used by BOTH the client file-select guard (blocking Continue on a divergent
 * sibling) and the server's authoritative group enforcement at analyze/finalize —
 * one function, no drift. Pure and isomorphic.
 */

/** Collision-free, order-preserving encoding of a header's column names. */
export function schemaFingerprint(headers: readonly string[]): string {
  return JSON.stringify(headers.map((name) => name.trim()));
}
